import { ProjectStatus } from '@/features/projects/shared/types/project-status';
import { supabase } from '@/lib/supabase';

export const updateProjectStatus = async ({
  projectId,
  status,
}: {
  projectId: number;
  status: ProjectStatus;
}) => {
  const { error } = await supabase.rpc('manual_update_project_status', {
    p_project_id: projectId,
    p_status: status,
  });
  if (error) throw error;
};
